import { licenseApi } from '@/core/api/license'

export const {
  useGetLicenseQuery,
  useGetLicensesQuery,
  useCreateLicenseMutation,
  useUpdateLicenseMutation,
  useDeleteLicenseMutation,
  useDeleteLicensesMutation,
} = licenseApi
